(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rec-apparel-landing"]) return;
  try {
    
(function () {
  function initRecApparel() {
    var root = document.querySelector('[data-rec-apparel]');
    if (!root || root.dataset.motionBound === 'true') return;
    root.dataset.motionBound = 'true';

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    root.classList.add('rec-motion');
    var items = root.querySelectorAll('.rec-reveal, .rec-world-shift');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -5% 0px' });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecApparel, { once: true });
  } else {
    initRecApparel();
  }

  document.addEventListener('shopify:section:load', initRecApparel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rec-cart-assurance"]) return;
  try {
    
document.addEventListener('cart:update:count', (event) => {
  const value = event.detail?.count;
  if (typeof value !== 'string' && typeof value !== 'number') return;
  if (typeof value === 'string' && !/^\d+$/.test(value)) return;
  const count = Number(value);
  if (!Number.isSafeInteger(count) || count < 0) return;
  document.querySelectorAll('[data-rec-order-check-count]').forEach((element) => {
    const number = element.querySelector('[data-rec-order-check-number]');
    const label = element.querySelector('[data-rec-order-check-label]');
    if (number) number.textContent = String(count);
    if (label) label.textContent = count === 1 ? 'ITEM' : 'ITEMS';
    element.setAttribute('aria-label', count + (count === 1 ? ' item in cart' : ' items in cart'));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rec-cart-intro"]) return;
  try {
    
document.addEventListener('cart:update:count', (event) => {
  const value = event.detail?.count;
  if (typeof value !== 'string' && typeof value !== 'number') return;
  if (typeof value === 'string' && !/^\d+$/.test(value)) return;
  const count = Number(value);
  if (!Number.isSafeInteger(count) || count < 0) return;
  document.querySelectorAll('[data-rec-cart-heading-count]').forEach((element) => {
    element.textContent = count > 0
      ? 'REC CART • ' + count + (count === 1 ? ' ITEM' : ' ITEMS')
      : 'REC CART • CURRENTLY EMPTY';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rec-tumbler-landing"]) return;
  try {
    
(function () {
  function initRecTumblers() {
    var root = document.querySelector('[data-rec-tumblers]');
    if (!root || root.dataset.motionBound === 'true') return;
    root.dataset.motionBound = 'true';

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.classList.add('rec-tumbler-motion');
    var items = root.querySelectorAll('.rec-tumbler-reveal');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecTumblers, { once: true });
  } else {
    initRecTumblers();
  }
  document.addEventListener('shopify:section:load', initRecTumblers);
})();

  } catch(e) { console.error(e); }
})();
})();
